/** Created by azhou on 2019/2/26.*/
<template>
  <div :class="nones==1&&'wrap'" class="rectangle-wrap" :style="{background:bgColor}">
    <slot></slot>
    <div class="big-circle"></div>
    <div class="middle-circle"></div>
    <div class="small-circle"></div>
  </div>
</template>

<script>

  export default {
    name: 'hexagonComp',
    props: {
      bgColor: {},
      nones:{}
    }
  }
</script>
<style lang="scss" scoped>
  .rectangle-wrap {
    border-radius: 5px;
    color: #fff;
    position: relative;
    max-width: 260px;
    min-width: 23%;
    height: 220px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 20px;
    padding-top: 30px;
    box-sizing: border-box;
    user-select: none;
    h4{
      font-size: 20px;
      margin-bottom: 8px;
    }
    p{
      margin-bottom: 8px;
      cursor: pointer;
      &:hover{
        span{
          color: red;
        }
      }
    }
    &:hover{
      box-shadow: 3px 3px 8px 3px #ddd;
    }
  }

  .big-circle,.middle-circle,.small-circle {
    position: absolute;
    border-radius: 100%;
    background: rgba(255,255,255,.3);
  }
  .big-circle{
    right: -50px;
    top: -50px;
    width: 150px;
    height: 150px;
  }
  .middle-circle{
    right: 60px;
    top: 120px;
    width: 30px;
    height: 30px;
  }
  .small-circle{
    right: 120px;
    top: 130px;
    width: 10px;
    height: 10px;
  }
  .wrap{
    min-width: 32%;
  }
</style>
